export const SALES_FUNNEL_PATH = "/sales-funnel";
